import { Skeleton } from '@/components/ui/skeleton'

export function AppShellSkeleton() {
  return (
    <>
      <div className="hidden md:flex min-h-screen w-full bg-background text-foreground">
        <aside className="relative z-40 sticky top-0 flex h-screen w-64 shrink-0 flex-col bg-background after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-px after:bg-gradient-to-b after:from-transparent after:via-border/70 after:to-transparent">
          <div className="flex h-16 items-center px-3">
            <Skeleton className="h-9 w-36 rounded-md" />
          </div>

          <div className="flex-1 space-y-1 px-2 py-3">
            {Array.from({ length: 7 }).map((_, index) => (
              <div key={index} className="flex items-center gap-3 rounded-lg px-3 py-2.5">
                <Skeleton className="h-4.5 w-4.5 rounded-sm" />
                <Skeleton className="h-4 w-28 rounded-md" />
              </div>
            ))}
          </div>

          <div className="p-2">
            <div className="flex items-center gap-3 rounded-lg px-3 py-2.5">
              <Skeleton className="h-4.5 w-4.5 rounded-sm" />
              <Skeleton className="h-4 w-16 rounded-md" />
            </div>
          </div>
        </aside>

        <div className="relative min-h-screen min-w-0 w-full flex-1 bg-background">
          <header className="sticky top-0 z-20 w-full bg-background">
            <div className="flex h-14 w-full items-center gap-4 px-4 md:px-6">
              <div className="flex items-center gap-3">
                <Skeleton className="h-8 w-8 rounded-md" />
                <Skeleton className="h-4 w-40 rounded-md" />
              </div>

              <div className="ml-auto flex items-center gap-2">
                <Skeleton className="h-8 w-28 rounded-full" />
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-8 w-8 rounded-full" />
                <Skeleton className="h-8 w-32 rounded-full" />
              </div>
            </div>
          </header>

          <div className="w-full space-y-6 px-4 py-4 md:px-6 md:py-6">
            <div className="space-y-2">
              <Skeleton className="h-8 w-72" />
              <Skeleton className="h-4 w-96 max-w-full" />
            </div>

            <div className="grid gap-4 xl:grid-cols-4 md:grid-cols-2">
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="space-y-4 rounded-xl bg-card p-6">
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-8 w-8 rounded-full" />
                    <Skeleton className="h-4 w-28" />
                  </div>
                  <Skeleton className="h-8 w-16" />
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-4 w-36" />
                </div>
              ))}
            </div>

            <div className="space-y-4 rounded-xl bg-card p-6">
              <div className="flex items-center justify-between gap-4">
                <Skeleton className="h-6 w-40" />
                <div className="flex gap-3">
                  <Skeleton className="h-10 w-48 rounded-xl" />
                  <Skeleton className="h-10 w-32 rounded-xl" />
                </div>
              </div>

              <div className="space-y-3">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div key={index} className="grid grid-cols-[1.1fr_1fr_0.8fr_0.5fr_0.5fr_0.5fr_24px] items-center gap-4">
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-10 w-full" />
                    <Skeleton className="h-8 w-20 rounded-full" />
                    <Skeleton className="h-6 w-10" />
                    <Skeleton className="h-6 w-10" />
                    <Skeleton className="h-6 w-10" />
                    <Skeleton className="h-6 w-6 rounded-md" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden min-h-screen bg-background px-4 py-4 text-foreground">
        <div className="space-y-6">
          <div className="flex h-14 items-center justify-between">
            <Skeleton className="h-8 w-8 rounded-md" />
            <div className="flex items-center gap-2">
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="h-8 w-8 rounded-full" />
              <Skeleton className="h-8 w-8 rounded-full" />
            </div>
          </div>

          <div className="space-y-2">
            <Skeleton className="h-8 w-52" />
            <Skeleton className="h-4 w-64 max-w-full" />
          </div>

          <div className="grid gap-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="space-y-4 rounded-xl bg-card p-5">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-8 w-8 rounded-full" />
                  <Skeleton className="h-4 w-24" />
                </div>
                <Skeleton className="h-8 w-16" />
                <Skeleton className="h-4 w-28" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
